import { readGracePeriodFromSession } from "../../Containers/grace-period/utils";
import { normalizeCustomerType } from "../../utils/common";

import { getInvoicePdfPresignedUrl } from "../../actions/invoice";
import { fetchUsageCredits } from "../../actions/usage";

export default async function fetchAccessStatus(signal) {
  const stored = readGracePeriodFromSession();

  try {
    const credits = await fetchUsageCredits(signal);
    if (credits.canceled) {
      return { canceled: true, ...stored };
    }

    if (!credits.success) {
      return stored;
    }

    return {
      customer_type: normalizeCustomerType(credits.customer_type),
      grace_period_status: credits.grace_period_status,
      grace_ends_on: credits.grace_ends_on,
      grace_days_left: credits.grace_days_left,
      grace_amount_due: credits.grace_amount_due,
      grace_days_overdue: credits.grace_days_overdue,
      invoice_id: credits.invoice_id,
      invoice_amount_due: credits.invoice_amount_due,
      invoice_pdf_path: credits.invoice_pdf_path,
      total_credits: credits.total_credits,
    };
  } catch (error) {
    return stored;
  }
}

/**
 * @param {string} pdfPath
 * @param {AbortSignal} [signal]
 */
export async function fetchDueInvoicePreviewUrl(pdfPath, signal) {
  return getInvoicePdfPresignedUrl(pdfPath, signal);
}
